module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Bold-WebS-dfd6f9413a58d64a185465235aaf7c8b.woff2";